import {
  DEFAULT_LOCAL_RESOLVER_ORIGIN,
  DEFAULT_PLATFORM_FALLBACK_URL,
  DEFAULT_PLATFORM_RESOLVER_DOMAIN,
} from '@myplayer/config';

const LOOPBACK_HOST_REGEX = /^(?:localhost|127\.0\.0\.1)(?::\d+)?$/i;

function readEnvValue(key: string): string | undefined {
  const metaVal = (
    import.meta as { readonly env?: Readonly<Record<string, string | undefined>> }
  ).env?.[key]?.trim();
  if (metaVal && metaVal.length > 0) {
    return metaVal;
  }
  const procVal = (
    globalThis as { readonly process?: { readonly env?: Record<string, string | undefined> } }
  ).process?.env?.[key]?.trim();
  return procVal && procVal.length > 0 ? procVal : undefined;
}

export function isLocalAdminMode(): boolean {
  if (
    readEnvValue('VITE_FIRESTORE_EMULATOR_HOST') !== undefined ||
    readEnvValue('VITE_FIREBASE_AUTH_EMULATOR_HOST') !== undefined ||
    readEnvValue('VITE_FIREBASE_FUNCTIONS_EMULATOR_HOST') !== undefined ||
    readEnvValue('MYPLAYER_ENV') === 'local'
  ) {
    return true;
  }
  const isVitest = readEnvValue('VITEST') === 'true';
  const isViteDev =
    (import.meta as { readonly env?: { readonly DEV?: boolean } }).env?.DEV === true;
  return isViteDev && !isVitest;
}

export function resolveEffectiveHost(resolverHost?: string): string {
  const explicit = resolverHost?.trim();
  if (explicit && explicit.length > 0) {
    return explicit;
  }
  const configuredHost = readEnvValue('VITE_RESOLVER_HOST');
  if (configuredHost !== undefined) {
    return configuredHost;
  }
  if (isLocalAdminMode()) {
    return DEFAULT_LOCAL_RESOLVER_ORIGIN;
  }
  return DEFAULT_PLATFORM_RESOLVER_DOMAIN;
}

export function resolveEffectiveOrigin(resolverHost?: string): string {
  const raw = resolveEffectiveHost(resolverHost).trim().replace(/\/+$/, '');
  if (/^https?:\/\//i.test(raw)) {
    return raw.toLowerCase();
  }
  const cleanHost = raw.toLowerCase();
  const scheme = LOOPBACK_HOST_REGEX.test(cleanHost) ? 'http' : 'https';
  return `${scheme}://${cleanHost}`;
}

export function resolveEffectiveHostname(resolverHost?: string): string {
  const raw = resolveEffectiveHost(resolverHost)
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/+$/, '')
    .toLowerCase();
  return raw.replace(/:\d+$/, '');
}

export function resolveExampleBrandHostname(resolverHost?: string): string {
  const hostname = resolveEffectiveHostname(resolverHost);
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.length === 0) {
    return 'brand.example.com';
  }
  return hostname;
}

export function resolveDefaultFallbackUrl(): string {
  return DEFAULT_PLATFORM_FALLBACK_URL;
}

export function resolveAdminEmailPlaceholder(prefix = 'admin'): string {
  return `${prefix}@${DEFAULT_PLATFORM_RESOLVER_DOMAIN}`;
}
